import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";
import { TipoReporteGuiasEnviadasRecibidas, CondicionEntregaReporteGuiasEnviadasRecibidas, OrdenReporteGuiasEnviadasRecibidas } from "app/features/selectores/index";

type Entity = models.ParamsGuiasEnviadasRecibidas;

export interface State {
    value: Entity;
}

/**
* Componente para editar un Entity
*/
export class ReporteGuiasEnviadasRecibidas extends React.PureComponent<{}, State> {
    constructor(props) {
        super(props);
        this.state = {
            value: {} as Entity
        };
    }

    errors = () => validation.getErrors(this.rules, this.state.value);
    getField = formfields(() => ({
        value: this.state.value,
        onChange: (x: Entity) => this.setState({ value: x })
    }), this.errors);

    get rules(): validation.Rules<Entity> {
        return {
            fechaDesde: validation.required,
            fechaHasta: validation.required,
            tipoReporte: validation.required
        };
    }

    onGenerarGuiasEnviadasRecibidas = async () => {
        const reporte = await resources.RepGuiasEnviadasRecibidas.Generar(this.state.value);
        await kea.download(reporte, "Reporte guías enviadas y recibidas.xls");
    }

    render() {
        const getField = this.getField;
        const DateTime = getField(kea.DateTime);
        const Sucursal = getField(selectores.Sucursal);
        const TipoReporte = getField(TipoReporteGuiasEnviadasRecibidas);
        const CondicionEntrega = getField(CondicionEntregaReporteGuiasEnviadasRecibidas);
        const Orden = getField(OrdenReporteGuiasEnviadasRecibidas);

        return (
            <div>
                <kea.Title titulo="Reporte de guías enviadas y recibidas" onRegresar={() => history.go("../")} />
                {kea.autogrid(6, [
                    <DateTime field="fechaDesde" label="Fecha desde"/>,
                    <DateTime field="fechaHasta" label="Fecha hasta"/>,
                    <TipoReporte field="tipoReporte" label="Tipo de reporte" />,
                    <CondicionEntrega field="condicionEntrega" label="Condición de entrega" />,
                    <Sucursal field="idSucursal" label="Sucursal" />,
                    <Orden field="orden" label="Ordenar por" />
                ])}

                <div className="row">
                    <div className="col-md-12">
                        <kea.Button children="Generar reporte" style="success" onClick={this.onGenerarGuiasEnviadasRecibidas}  disabled={validation.hasError(this.errors())} />
                    </div>
                </div>
            </div>);
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/reporteguiasenviadasrecibidas/index.tsx